import { CapoPlugin } from "/home/runner/work/wdd/wdd/frontend/ubs/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];